import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchAstroProfile } from '../../../../redux/actions/astrologerActions'
import { Link } from 'react-router-dom'
import Loader from '../../../../loader/Loader'
import { IMG_BASE_URL } from '../../../../config/Config'
import Astrologer_after_Login_Header from '../astrologer_after_login_header/Astrologer_after_Login_Header'
import Slider from 'react-slick'

const Pandit_Save_Profile = () => {
    const dispatch = useDispatch();
    const { profile, isloading, error } = useSelector((state) => state.astrologer);
    console.log("profile:", profile)

    // useEffect(() => {
    //     const handle_astrologer_save_profile = async () => {
    //         setis_loading(true)
    //         try {
    //             const token = User_Authentication();
    //             if (!token) {
    //                 setis_loading(false);
    //                 toast("token not found's")
    //                 throw new Error("User token not found");
    //             }
    //             const response = await get_astro_profile({ Authorization: `Bearer ${token}` })
    //             if (response?.data?.status == true) {
    //                 set_Astro_Profile(response?.data?.data)
    //                 setis_loading(false)
    //             }
    //             else if (response?.response?.data?.status == false) {
    //                 setis_loading(false)
    //             }
    //         }
    //         catch (error) {
    //             setis_loading(false)
    //         }
    //     }
    //     handle_astrologer_save_profile();
    // }, [])

    // Dispatch Redux action to fetch profile data
    useEffect(() => {
        dispatch(fetchAstroProfile());
    }, [dispatch]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    const slidesToShow = profile?.profile_images?.length < 4 ? profile?.profile_images?.length : 4;

    const settings = {
        infinite: profile?.profile_images?.length > 1,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        autoplay: profile?.profile_images?.length > 1,
        autoplaySpeed: 2000,
        arrows: profile?.profile_images?.length > 1,
        variableWidth: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: profile?.profile_images?.length < 3 ? profile?.profile_images?.length : 3,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: profile?.profile_images?.length < 2 ? profile?.profile_images?.length : 2,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    // Scroll to the top of the page when the component is rendered
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div>
            {/*  */}
            <Astrologer_after_Login_Header />
            {/* <-------- ToastContainer ------------> */}
            {
                isloading ? (
                    <Loader />
                ) : (
                    <section className="bg-[#f8f9fa] py-8 px-4 sm:px-6 lg:px-8 pt-24 lg:pt-10">
                        <div className="max-w-[1000px] mx-auto pb-5">
                            <div className="flex items-center justify-between gap-4 mb-6">
                                <h2 className="text-xl font-bold text-gray-800">My Profile</h2>
                                <div className="flex items-center gap-3">
                                    <Link
                                        to="/pandit-save-profile-update"
                                        className="bg-[#9F2225] hover:bg-[#851c1e] text-white text-sm p-2 rounded-xl flex items-center justify-center w-10 h-10 shadow-sm transition-all duration-200"
                                        title="Edit Profile"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"/>
                                        </svg>
                                    </Link>
                                    <Link
                                        to="/pandit-home"
                                        className="bg-[#9F2225] hover:bg-[#851c1e] text-white text-sm py-2.5 px-4 rounded-xl flex items-center gap-2 shadow-sm transition-all duration-200 font-semibold"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-house-door-fill" viewBox="0 0 16 16">
                                            <path d="M6.5 14.5v-3.507c0-.235.19-.425.426-.425h2.148c.237 0 .426.19.426.425V14.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5V7.914a.5.5 0 0 0-.152-.353l-6-6a.5.5 0 0 0-.707 0l-6 6a.5.5 0 0 0-.152.353V14.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5"/>
                                        </svg>
                                        Go to Home
                                    </Link>
                                </div>
                            </div>

                            <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-100 p-5 sm:p-6 lg:p-8">
                                <h3 className="text-lg font-bold text-gray-800 tracking-tight mb-6 pb-2 border-b border-gray-100">Basic Details</h3>

                                <div className="gi-product-content overflow-hidden">
                                    <div className="flex flex-col sm:flex-row gap-6 transition-all duration-[0.3s] ease-in-out items-center sm:items-start text-center sm:text-left">
                                        <div className="flex-shrink-0">
                                            <img 
                                                className="w-36 h-36 rounded-2xl object-cover border border-gray-100 shadow-sm bg-gray-50 p-1"
                                                src={`${IMG_BASE_URL}${profile?.profile_image}`} 
                                                alt="astrologer" 
                                            />
                                        </div>
                                        <div className="w-full">
                                            <h5 className="font-bold text-gray-800 text-xl tracking-tight">{profile?.name}</h5>

                                            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <div>
                                                    <h6 className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Languages</h6>
                                                    <div className="flex flex-wrap gap-1.5 mt-1.5 justify-center sm:justify-start">
                                                        {profile?.language?.split(',').map((lang, i) => (
                                                            <span
                                                                key={i}
                                                                className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold text-gray-600 bg-gray-50 border border-gray-100"
                                                            >
                                                                {lang.trim()}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                                <div>
                                                    <h6 className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Experience</h6>
                                                    <span className="inline-flex items-center mt-1.5 px-3 py-1 rounded-full text-xs font-semibold text-gray-600 bg-gray-50 border border-gray-100">
                                                        {profile?.experience} Year(s)
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="mt-4">
                                                <h6 className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Skills</h6>
                                                <div className="flex flex-wrap gap-1.5 mt-1.5 justify-center sm:justify-start">
                                                    {profile?.skills?.split(',').map((skill, i) => (
                                                        <span
                                                            key={i}
                                                            className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold text-gray-600 bg-gray-50 border border-gray-100"
                                                        >
                                                            {skill.trim()}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* About Us info grid */}
                                    <div className="border-t border-gray-100 mt-6 pt-6">
                                        <h5 className="text-base font-bold text-gray-800 tracking-tight mb-4">Personal Information</h5>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                                            {[
                                                { label: "Phone No.", value: `${profile?.country_code} ${profile?.mobile}` },
                                                { label: "Email Address", value: profile?.email },
                                                { label: "Gender", value: profile?.gender },
                                                { label: "Place of Birth", value: profile?.astrodetail?.birth_place },
                                                { label: "Faith", value: profile?.astrodetail?.faith },
                                                { label: "City", value: profile?.astrodetail?.city },
                                                { label: "Date of Birth", value: formatDate(profile?.astrodetail?.dob) },
                                                { label: "Address", value: profile?.astrodetail?.address },
                                            ].map((item, index) => (
                                                item.value && (
                                                    <div key={index} className="overflow-hidden">
                                                        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">{item.label}</span>
                                                        <h5 className="text-sm font-bold text-gray-700 mt-1 truncate">
                                                            {item.value}
                                                        </h5>
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    </div>

                                    {/* About us text */}
                                    <div className="border-t border-gray-100 mt-6 pt-6">
                                        <h5 className="text-base font-bold text-gray-800 tracking-tight mb-3">About Me</h5>
                                        <p className="text-sm text-gray-500 leading-relaxed bg-gray-50/50 border border-gray-100 rounded-xl p-4">{profile?.astrodetail?.about_us}</p>
                                    </div>

                                    {/* Gallery */}
                                    <div className="border-t border-gray-100 mt-6 pt-6">
                                        <h5 className="text-base font-bold text-gray-800 tracking-tight mb-4">Gallery</h5>
                                        {profile?.profile_images?.length > 0 ? (
                                            <div className="w-full">
                                                <Slider {...settings} className="px-1">
                                                    {profile?.profile_images?.map((img, index) => (
                                                        <div key={index} className="px-2">
                                                            <img
                                                                className="w-full h-40 object-cover rounded-xl border border-gray-100 bg-white p-1"
                                                                src={`${IMG_BASE_URL}${img?.image_file}`}
                                                                alt={`Gallery ${index}`}
                                                            />
                                                        </div>
                                                    ))}
                                                </Slider>
                                            </div>
                                        ) : (
                                            <p className="text-sm text-gray-400">No gallery images uploaded.</p>
                                        )}
                                    </div>

                                    {/* Qualification */}
                                    <div className="border-t border-gray-100 mt-6 pt-6">
                                        <h5 className="text-base font-bold text-gray-800 tracking-tight mb-4">Qualification</h5>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
                                            {[
                                                { label: "Highest Qualification", value: profile?.astrodetail?.highest_qualification },
                                                { label: "Degree/Diploma", value: profile?.astrodetail?.degree },
                                                { label: "College/School/University", value: profile?.astrodetail?.collage_school },
                                                { label: "Astro Learning Source", value: profile?.astrodetail?.from_astroogy },
                                            ].map((item, index) => (
                                                item.value && (
                                                    <div key={index}>
                                                        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">{item.label}</span>
                                                        <h5 className="text-sm font-bold text-gray-700 mt-1">{item.value}</h5>
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    </div>

                                    {/* Price Rates */}
                                    <div className="border-t border-gray-100 mt-6 pt-6">
                                        <h5 className="text-base font-bold text-gray-800 tracking-tight mb-4">Pricing Rates</h5>
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                            <div className="p-4 bg-gray-50/50 border border-gray-100 rounded-2xl flex flex-col justify-center">
                                                <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Chat Rate</span>
                                                <h5 className="text-base font-bold text-[#9F2225] mt-1">₹{profile?.astro_amounts?.chat_rate}.00 / min</h5>
                                            </div>
                                            <div className="p-4 bg-gray-50/50 border border-gray-100 rounded-2xl flex flex-col justify-center">
                                                <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Call Rate</span>
                                                <h5 className="text-base font-bold text-[#9F2225] mt-1">₹{profile?.astro_amounts?.audio_call_rate}.00 / min</h5>
                                            </div>
                                            <div className="p-4 bg-gray-50/50 border border-gray-100 rounded-2xl flex flex-col justify-center">
                                                <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">Emergency Call Rate</span>
                                                <h5 className="text-base font-bold text-[#9F2225] mt-1">₹{profile?.astro_amounts?.emergency_audio_call_rate}.00 / min</h5>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Social Links */}
                                    <div className="border-t border-gray-100 mt-6 pt-6">
                                        {profile?.astrodetail?.instagram && profile?.astrodetail?.facebook && profile?.astrodetail?.linked_in && profile?.astrodetail?.youtube && profile?.astrodetail?.website && (
                                            <h5 className="text-base font-bold text-gray-800 tracking-tight mb-4">Social Media Links</h5>
                                        )}
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                                            {[
                                                { label: "Instagram", link: profile?.astrodetail?.instagram },
                                                { label: "Facebook", link: profile?.astrodetail?.facebook },
                                                { label: "LinkedIn", link: profile?.astrodetail?.linked_in },
                                                { label: "YouTube", link: profile?.astrodetail?.youtube },
                                                { label: "Website", link: profile?.astrodetail?.website },
                                            ].map((item, index) => (
                                                item.link && (
                                                    <div key={index}>
                                                        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">{item.label} Link</span>
                                                        <h5 className="text-sm font-semibold text-[#2F80ED] mt-1 truncate">
                                                            <a href={item.link} target="_blank" rel="noopener noreferrer" className="hover:underline">
                                                                {item.link}
                                                            </a>
                                                        </h5>
                                                    </div>
                                                )
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>

                )
            }
        </div>
    )
}

export default Pandit_Save_Profile